/**
 * Step key constants for Create Listing wizard
 * Use these constants instead of string literals for type safety and refactoring.
 */

export const STEP_KEYS = {
  // Room for rent specific steps
  ROOM_WHO_IS_LISTING_PROPERTY: 'ROOM_WHO_IS_LISTING_PROPERTY',
  ROOM_DESCRIPTION: 'ROOM_DESCRIPTION',
  ROOM_HOW_MANY_ROOMMATES: 'ROOM_HOW_MANY_ROOMMATES',
  ROOMMATE_DESCRIPTION: 'ROOMMATE_DESCRIPTION',
  RENTER_PREFERENCES: 'RENTER_PREFERENCES',
  ROOM_CURRENT_PETS: 'ROOM_CURRENT_PETS',
  ROOM_UTILITIES_AMOUNT: 'ROOM_UTILITIES_AMOUNT',

  // Property info steps
  PROPERTY_INFO: 'PROPERTY_INFO',
  PROPERTY_DESCRIPTION: 'PROPERTY_DESCRIPTION',
  HIDE_PROPERTY_ADDRESS: 'HIDE_PROPERTY_ADDRESS',
  DESCRIBE_PROPERTY: 'DESCRIBE_PROPERTY',

  // Rent details steps
  MONTHLY_RENT_AND_SECURITY_DEPOSIT: 'MONTHLY_RENT_AND_SECURITY_DEPOSIT',
  WHEN_IS_PROPERTY_AVAILABLE: 'WHEN_IS_PROPERTY_AVAILABLE',

  // Media steps
  ADD_PHOTOS: 'ADD_PHOTOS',

  // Amenities steps
  AMENITIES_INTERIOR: 'AMENITIES_INTERIOR',
  AMENITIES_PROPERTY: 'AMENITIES_PROPERTY',

  // Screening criteria steps
  FINANCIAL_EXPECTATIONS: 'FINANCIAL_EXPECTATIONS',
  PET_POLICY: 'PET_POLICY',
  PET_POLICY_AND_PET_FEE: 'PET_POLICY_AND_PET_FEE',

  // Costs and fees steps
  COSTS_AND_FEES: 'COSTS_AND_FEES',

  // Final details steps
  LEASE_DURATION: 'LEASE_DURATION',
  LEASE_DESCRIPTION: 'LEASE_DESCRIPTION',
  WHO_IS_LISTING_PROPERTY: 'WHO_IS_LISTING_PROPERTY',
  PHONE_NUMBER: 'PHONE_NUMBER',
  ALLOW_CONTACT_BY_PHONE: 'ALLOW_CONTACT_BY_PHONE',
  ACCEPT_ZILLOW_APPLICATIONS: 'ACCEPT_ZILLOW_APPLICATIONS',

  // Tour scheduling steps
  TOUR_SCHEDULING_BOOKING_METHOD: 'TOUR_SCHEDULING_BOOKING_METHOD',
  TOUR_SCHEDULING_TIMEZONE: 'TOUR_SCHEDULING_TIMEZONE',
  TOUR_SCHEDULING_AVAILABILITY: 'TOUR_SCHEDULING_AVAILABILITY',

  // Tour scheduling steps for relisting
  TOUR_SCHEDULING_BOOKING_METHOD_RELIST: 'TOUR_SCHEDULING_BOOKING_METHOD_RELIST',
  TOUR_SCHEDULING_TIMEZONE_RELIST: 'TOUR_SCHEDULING_TIMEZONE_RELIST',
  TOUR_SCHEDULING_AVAILABILITY_RELIST: 'TOUR_SCHEDULING_AVAILABILITY_RELIST',

  // Fast post and review steps
  FAST_POST_REVIEW: 'FAST_POST_REVIEW',
  REVIEW: 'REVIEW',
  PAY_AND_PUBLISH: 'PAY_AND_PUBLISH',

  // Relisting steps
  UPDATE_RECENTLY_CHANGED: 'UPDATE_RECENTLY_CHANGED',
  CONSIDER_ADDITIONAL_DETAILS: 'CONSIDER_ADDITIONAL_DETAILS',

  // Multiplex listing steps
  MULTIPLEX_PROPERTY_DETAILS: 'MULTIPLEX_PROPERTY_DETAILS',
  MULTIPLEX_OVERVIEW: 'MULTIPLEX_OVERVIEW',
  MULTIPLEX_LISTING_PUBLISHED: 'MULTIPLEX_LISTING_PUBLISHED',
} as const;

export type StepKey = (typeof STEP_KEYS)[keyof typeof STEP_KEYS];

export const PROGRESS_STEP_KEYS = {
  PROPERTY_INFO: 'property-info',
  RENT_DETAILS: 'rent-details',
  MEDIA: 'media',
  AMENITIES: 'amenities',
  SCREENING_CRITERIA: 'screening-criteria',
  COSTS_AND_FEES: 'costs-and-fees',
  FINAL_DETAILS: 'final-details',
  REVIEW: 'review',
  PAY_AND_PUBLISH: 'pay-and-publish',
  UPDATE: 'update',
  TOUR_BOOKING: 'tour-booking',
  PROPERTY_DETAILS: 'property-details',
  MULTIPLEX_OVERVIEW: 'multiplex-overview',
  PUBLISHED: 'published',
} as const;

export type ProgressStepKey = (typeof PROGRESS_STEP_KEYS)[keyof typeof PROGRESS_STEP_KEYS];

export const STEP_DELIMITER = '::';
export const RELISTING_STEP_SUFFIX = 'relisting';
